<template>
  <div>
    <div>
      <load-profile />
      <b-card id="container" ref="container">
        <b-card-text class="mb-2">
          <h5>
            {{ $t("topic_summary_desc") }}
          </h5>
        </b-card-text>
        <div class="d-flex flex-row mb-4 mr-4">
          <div
            class="d-flex flex-row flex-item--half border rounded px-2 py-2 justify-content-between"
            :class="enable ? 'border-primary' : ''"
            @click="enable = !enable"
          >
            <div class="d-flex flex-column">
              <h4>
                {{ $t("enable_topic_summary") }}
              </h4>
              <span>{{ $t("enable_topic_summary_desc") }}</span>
            </div>
            <b-form-checkbox v-model="enable" @change="enable = !enable" />
          </div>
        </div>
        <div class="d-flex flex-row justify-content-end">
          <b-button variant="primary" @click="updateTopicSummary">
            {{ $t("button.saveChanges") }}
          </b-button>
        </div>
      </b-card>
    </div>
  </div>
</template>

<script>
import { BCard, BCardText, BFormCheckbox, BButton } from "bootstrap-vue";
import Repository from "@/repositories/RepositoryFactory";
import questionRepository from "@/repositories/Api/QuestionRepository";

const MerchantRepository = Repository.get("merchant");

export default {
  components: {
    BCard,
    BCardText,
    BFormCheckbox,
    BButton,
  },
  data: () => ({

    enable: false,
  }),
  watch: {
  },
  async mounted() {
    await this.getMerchant();
  },
  methods: {
    async getMerchant() {
      try {
        const response = await MerchantRepository.show();
        const { data } = response.data;
        this.enable = data.isEnableTopicSummary || false;

      } catch (err) {
        const { data } = err.response;
        const { message } = data;
        if (message === "error.recordNotFound") await this.createAssignment();
      }
    },
    async updateTopicSummary() {
      try {
        const payload = {
          isEnableTopicSummary: this.enable,
        };
        await questionRepository.enable(payload);
      } catch (err) {
        alert(err);
      } finally {
        await this.getMerchant();
      }
    },
  },
  setup() {
    const permissionType = "summary-conversation";
    return { permissionType };
  },
};
</script>

<style class="scss" scoped>
.flex-item--half {
  cursor: pointer;
  width: 100%;
  max-width: 50%;
}
</style>
